import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import HeadingTextBlock from 'components/Luxkit/TextBlocks/HeadingTextBlock'
import React, { MouseEventHandler, useCallback, useContext, useMemo } from 'react'
import { LuxAwardModalDispatchActions, LuxAwardModalDispatchContext } from './LuxAwardModalContexts'
import { PRIZES, RUNNER_UP_PRIZES } from './luxAwardPrizes'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import ListItem from 'components/Luxkit/List/ListItem'
import TextButton from 'components/Luxkit/Button/TextButton'
import HeroImage from 'content/components/HeroImage'
import Group from 'components/utils/Group'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import { themeClassName } from 'lib/theme/themeUtils'
import styled from 'styled-components'
import { rem } from 'polished'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import GeoContext from 'contexts/geoContext'
import { mediaQueryUp } from 'components/utils/breakpoint'
import BodyText from 'components/Luxkit/Typography/BodyText'

const VOTING_URLS = {
  AU: '/campaign/lux-list-travel-travel-awards-voting',
  US: '/campaign/lux-list-travel-travel-awards-voting-us',
  GB: '/campaign/lux-list-travel-travel-awards-voting-uk',
}

const GRAND_PRIZES = PRIZES.filter(prize => prize.type === 'Grand Prize')
const HeroContainer = styled.div`
  z-index: 1;
  padding: ${rem(32)} ${rem(20)};
  display: grid;
  place-items: center;
  background-color: rgba(0,0,0,0.3);
  width: 100%;
  height: 100%;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} ${rem(120)};
  }
`

const StyledHeroImage = styled(HeroImage)`
  padding: 0;
`
function LuxAwardModalStepHome() {
  const dispatch = useContext(LuxAwardModalDispatchContext)
  const { currentRegionCode } = useContext(GeoContext)
  const runnerUpPrize = useMemo(() => currentRegionCode in RUNNER_UP_PRIZES ? RUNNER_UP_PRIZES[currentRegionCode] : RUNNER_UP_PRIZES.AU, [currentRegionCode])
  const voteUrl = currentRegionCode in VOTING_URLS ? VOTING_URLS[currentRegionCode] : VOTING_URLS.AU

  const handlePrizeViewClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    const step = String(event.currentTarget.dataset.prizekey)
    dispatch({ type: LuxAwardModalDispatchActions.GO_TO, step })
  }, [dispatch])

  return <>
    <ModalHeader
    title=""
    />
    <ModalBody>
      <StyledHeroImage
        id="q7eqq1113a534wwvj2xm"
        aspectRatio="3.15"
        className={themeClassName('inverse')}
      >
        <HeroContainer>
          <Group direction="vertical" gap={8} horizontalAlign="center">
            <HeadingTextBlock variant="heading2alt" colour="neutral-one" align="center">Prizes</HeadingTextBlock>
            <BodyTextBlock variant="medium" colour="neutral-one" align="center">Vote for your favourite escapes and you'll be in the running to win incredible prizes, including a year of Luxury Escapes!</BodyTextBlock>
          </Group>
        </HeroContainer>
      </StyledHeroImage>
      <ModalContent>
        <Group direction="vertical" gap={20}>
          <Group direction="vertical">
            <HeadingTextBlock variant="heading3">Grand Prize</HeadingTextBlock>
            <BodyText variant="medium">A year of Luxury Escapes, with six retreats to enjoy throughout 2025*</BodyText>
            {GRAND_PRIZES.map((prize) => <ListItem key={prize.key} data-prizekey={prize.key} title={prize.title} startIcon={<ResponsiveImage height={48} width={48} aspectRatio="1:1" id={prize.image.id!} />} onClick={handlePrizeViewClick}>
              <TextButton kind="tertiary" size="medium" nonInteractable>View prize</TextButton>
            </ListItem>)}
          </Group>
          <Group direction="vertical">
            <HeadingTextBlock variant="heading3">Runner-Up Prizes</HeadingTextBlock>
            <ListItem key="runner-up-prize" data-prizekey="runner-up-prize" title={runnerUpPrize}>
            </ListItem>
          </Group>
        </Group>
      </ModalContent>
    </ModalBody>
    <ModalFooter
      primaryActionProps={{
        children: 'Vote now',
        to: voteUrl,
      }}
    />
  </>
}

export default LuxAwardModalStepHome
